import { createContext, ReactNode, useContext } from 'react';

export interface IPaymentEnvContext {
	/** TrueLayer is not enabled in the Payment app */
	trueLayerAuthLinkBase?: string;
	trueLayerRedirectUrl?: string;
	enableOpenBankingEnv: boolean;
	stripeCustomCloseCallback?: string; // Deep link to the app after the payment flow is completed in the in-app browser Payment app
	paymentBaseUrl?: string; //Payment app base url. Native app opens in-app browser with Stripe page here.
	stripeWebCallback: string; //Where to redirect after Stripe redirect-based PMs. This is different for Web & Native apps.
	stripePublicKey: string;
}

const PaymentEnvContext = createContext<IPaymentEnvContext | null>(null);

interface IPaymentEnvProviderProps {
	children: ReactNode;
	value: IPaymentEnvContext;
}

export const PaymentEnvProvider = ({
	children,
	value,
}: IPaymentEnvProviderProps) => {
	return (
		<PaymentEnvContext.Provider value={value}>
			{children}
		</PaymentEnvContext.Provider>
	);
};

export const usePaymentEnv = (): IPaymentEnvContext => {
	const context = useContext(PaymentEnvContext);

	if (!context) {
		throw new Error('usePaymentEnv must be used within PaymentEnvProvider');
	}

	return context;
};
